import { Injectable } from '@angular/core';
import { Adminenvironment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
 

@Injectable({
  providedIn: 'root'
})
export class ModuleService {
 private readonly baseApiRoute = `${Adminenvironment.apiBaseUrl}`;

  constructor(private http: HttpClient) { }

  public getActiveModule(): Observable<any> {
    return this.http.get<any>(`${this.baseApiRoute}Modules/getActive`);
  }
}
